var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toggle-input"},[_c('v-switch',{attrs:{"input-value":_vm.value,"inset":""},on:{"change":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }